// extracted by mini-css-extract-plugin
export var askAiIcon = "_pc-9";
export var container = "_pc-0";
export var groupSeparator = "_pc-a";
export var highlight = "_pc-4";
export var resultIcon = "_pc-5";
export var resultItem = "_pc-7";
export var resultSubtitle = "_pc-3";
export var resultTitle = "_pc-2";
export var resultsList = "_pc-1";
export var searchGroup = "_pc-6";
export var selected = "_pc-8";